import { template as template_6042c8e952194501906e58c3623d87a1 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/html';
export default RouteTemplate(template_6042c8e952194501906e58c3623d87a1(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
